import NavBar from "./components/NavBar.jsx/NavBar";
import Body from "./components/Body/Body";
import './App.css';
import { useState } from "react";

const App = () => {
    const [Miusic, SetMiusic] = useState([
        { ID: 1, MiusicsIMG: '/assets/1.jpg', MiusicsTitle: 'متن آهنگ من ۲ از امیر تتلو:', MiusicsDescribtion: 'یک ، یک ، دو ، دو\nميخوام شعر بنويسم ، تو بگير بخواب !\nمن مالِ خواب نيستم !! هِه !!\nشب بخير !!\nشماره يک بيداره !! بيدارترين !!', MiusicAdress: '/assets/1.mp3' },
        { ID: 2, MiusicsIMG: '/assets/1.jpg', MiusicsTitle: 'title', MiusicsDescribtion: 'describtion', MiusicAdress: '/assets/1.mp3' },
        { ID: 2, MiusicsIMG: '/assets/1.jpg', MiusicsTitle: 'title', MiusicsDescribtion: 'describtion', MiusicAdress: '/assets/1.mp3' }
    ]);

    return (
        <div className="AlginCenter">
            <NavBar />
            {Miusic.map((item) => {
                const { ID, MiusicsIMG, MiusicsTitle, MiusicsDescribtion, MiusicAdress } = item;
                return (
                    <div key={ID} className="AlginCenter">
                        <Body 
                            ID={ID} 
                            MiusicsIMG={MiusicsIMG} 
                            MiusicsTitle={MiusicsTitle} 
                            MiusicsDescribtion={MiusicsDescribtion} 
                            MiusicAdress={MiusicAdress} 
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default App;
